import defaultLogo from "../../../assets/illustrations/carburate-logo-small.svg"; // fallback logo for unknown makes

import amc from "../../../assets/logos/AMC_v2.svg";
import abarth from "../../../assets/logos/abarth.svg";
import ac from "../../../assets/logos/ac.svg";
import acadian from "../../../assets/logos/acadian.svg";
import acura from "../../../assets/logos/acura.svg";
import adlerTrumpf from "../../../assets/logos/adler-trumpf.svg";
import aermacchi from "../../../assets/logos/aermacchi.svg";
import ahrensFox from "../../../assets/logos/ahrens-fox.svg";
import airfloat from "../../../assets/logos/airfloat.svg";
import alfaromeo from "../../../assets/logos/alfaromeo.svg";
import allAmericanRacers from "../../../assets/logos/all-american-racers.svg";
import allard from "../../../assets/logos/allard.svg";
import allstate from "../../../assets/logos/allstate.svg";
import alpine from "../../../assets/logos/alpine.svg";
import alvis from "../../../assets/logos/alvis.svg";
import americanBantam from "../../../assets/logos/american-bantam.svg";
import american from "../../../assets/logos/american.svg";
import amphicar from "../../../assets/logos/amphicar.svg";
import apollo from "../../../assets/logos/apollo.svg";
import apperson from "../../../assets/logos/apperson.svg";
import asa from "../../../assets/logos/asa.svg";
import astonmartin from "../../../assets/logos/astonmartin.svg";
import ats from "../../../assets/logos/ats.svg";
import auburn from "../../../assets/logos/auburn.svg";
import audi from "../../../assets/logos/audi.svg";
import austin_healey from "../../../assets/logos/austin-healey.svg";
import austin from "../../../assets/logos/austin.svg";
import avionsVoisin from "../../../assets/logos/avions-voisin.svg";
import bentley from "../../../assets/logos/bentley.svg";
import benz from "../../../assets/logos/benz.svg";
import bmw from "../../../assets/logos/bmw.svg";
import bristol from "../../../assets/logos/bristol.svg";
import brush from "../../../assets/logos/brush.svg";
import bugatti from "../../../assets/logos/bugatti.svg";
import buick from "../../../assets/logos/buick.svg";
import cadillac from "../../../assets/logos/cadillac.svg";
import cartercar from "../../../assets/logos/cartercar.svg";
import chevrolet from "../../../assets/logos/chevrolet.svg";
import chrysler from "../../../assets/logos/chrysler.svg";
import cisitalia from "../../../assets/logos/cisitalia.svg";
import citroen from "../../../assets/logos/citroen.svg";
import cole1 from "../../../assets/logos/cole-1.svg";
import cole from "../../../assets/logos/cole.svg";
import crosley from "../../../assets/logos/crosley.svg";
import cupra from "../../../assets/logos/cupra.svg";
import cushman from "../../../assets/logos/cushman.svg";
import daimler from "../../../assets/logos/daimler.svg";
import davis from "../../../assets/logos/davis.svg";
import delage from "../../../assets/logos/delage.svg";
import delahaye from "../../../assets/logos/delahaye.svg";
import dodge from "../../../assets/logos/dodge.svg";
import duesenberg from "../../../assets/logos/duesenberg.svg";
import emF from "../../../assets/logos/e-m-f.svg";
import erie from "../../../assets/logos/erskine.svg";
import essex from "../../../assets/logos/essex.svg";
import etnyre from "../../../assets/logos/etnyre.svg";
import ferrari from "../../../assets/logos/ferrari.svg";
import fiat from "../../../assets/logos/fiat.svg";
import ford from "../../../assets/logos/ford.svg";
import franklin from "../../../assets/logos/franklin.svg";
import frontenac from "../../../assets/logos/frontenac.svg";
import gardner from "../../../assets/logos/gardner.svg";
import ginetta from "../../../assets/logos/ginetta.svg";
import gmc from "../../../assets/logos/gmc.svg";
import healey from "../../../assets/logos/healey.svg";
import hsp from "../../../assets/logos/hispano-suiza.svg";
import honda from "../../../assets/logos/honda.svg";
import horch from "../../../assets/logos/horch.svg";
import hrg from "../../../assets/logos/hrg.svg";
import hudson from "../../../assets/logos/hudson.svg";
import humber from "../../../assets/logos/humber.svg";
import hupmobile from "../../../assets/logos/hupmobile.svg";
import internationalHarverster from "../../../assets/logos/internationalharverster.svg";
import invicta from "../../../assets/logos/invicta.svg";
import isottaFraschini from "../../../assets/logos/isotta-fraschini.svg";
import jaguar from "../../../assets/logos/jaguar.svg";
import jeep from "../../../assets/logos/jeep.svg";
import jeffery from "../../../assets/logos/jeffery.svg";
import jensen from "../../../assets/logos/jensen.svg";
import kaiser from "../../../assets/logos/kaiser.svg";
import knox from "../../../assets/logos/knox.svg";
import koenigsegg from "../../../assets/logos/koenigsegg-logo.svg";
import lagonda from "../../../assets/logos/lagonda.svg";
import lamborghini from "../../../assets/logos/lamborghini.svg";
import lanchester from "../../../assets/logos/lanchester.svg";
import lancia from "../../../assets/logos/lancia.svg";
import landrover from "../../../assets/logos/landrover.svg";
import laSalle from "../../../assets/logos/lasalle.svg";
import leaFrancis from "../../../assets/logos/lea-francis.svg";
import lexus from "../../../assets/logos/lexus.svg";
import lincoln from "../../../assets/logos/lincoln.svg";
import locomo from "../../../assets/logos/locomobile.svg";
import lotus from "../../../assets/logos/lotus.svg";
import lozier from "../../../assets/logos/lozier.svg";
import maserati from "../../../assets/logos/maserati.svg";
import maybach from "../../../assets/logos/maybach.svg";
import mazda from "../../../assets/logos/mazda.svg";
import mclaren from "../../../assets/logos/mclaren.svg";
import mercedes from "../../../assets/logos/mercedes.svg";
import mercury from "../../../assets/logos/mercury.svg";
import mg from "../../../assets/logos/mg.svg";
import mini from "../../../assets/logos/mini.svg";
import morgan from "../../../assets/logos/morgan.svg";
import morris from "../../../assets/logos/morris.svg";
import nash from "../../../assets/logos/nash.svg";
import nissan from "../../../assets/logos/nissan.svg";
import nsu from "../../../assets/logos/nsu.svg";
import oldsmobile from "../../../assets/logos/oldsmobile.svg";
import opel1 from "../../../assets/logos/opel-1.svg";
import opel from "../../../assets/logos/opel.svg";
import packard from "../../../assets/logos/packard.svg";
import pagani from "../../../assets/logos/pagani.svg";
import peerless from "../../../assets/logos/peerless.svg";
import peugeot from "../../../assets/logos/peugeot.svg";
import pierceArrow from "../../../assets/logos/pierce-arrow.svg";
import playboy from "../../../assets/logos/playboy.svg";
import plymouth from "../../../assets/logos/plymouth.svg";
import pontiac from "../../../assets/logos/pontiac.svg";
import porsche from "../../../assets/logos/porsche.svg";
import rambler from "../../../assets/logos/rambler.svg";
import renault from "../../../assets/logos/renault.svg";
import re0 from "../../../assets/logos/reo.svg";
import riley from "../../../assets/logos/riley.svg";
import rollsRoyce from "../../../assets/logos/rolls-royce.svg";
import rols from "../../../assets/logos/rols.svg";
import rover from "../../../assets/logos/rover.svg";
import seat from "../../../assets/logos/seat.svg";
import shelby from "../../../assets/logos/shelby.svg";
import simca from "../../../assets/logos/simca.svg";
import singer from "../../../assets/logos/singer.svg";
import skoda from "../../../assets/logos/skoda.svg";
import stanley from "../../../assets/logos/stanley.svg";
import studebaker from "../../../assets/logos/studebaker.svg";
import stutz from "../../../assets/logos/stutz.svg";
import subaru from "../../../assets/logos/subaru.svg";
import sunbeamTalbot from "../../../assets/logos/sunbeam-talbot.svg";
import suzuki from "../../../assets/logos/suzuki.svg";
import talbotLago from "../../../assets/logos/talbot-lago.svg";
import tata from "../../../assets/logos/tatra.svg";
import terraplane from "../../../assets/logos/terraplane.svg";
import tesla from "../../../assets/logos/tesla.svg";
import toyota from "../../../assets/logos/toyota.svg";
import triumph from "../../../assets/logos/triumph.svg";
import vauxhall1 from "../../../assets/logos/vauxhall-1.svg";
import vauxhall from "../../../assets/logos/vauxhall.svg";
import volksvagen from "../../../assets/logos/volksvagen.svg";
import volvo from "../../../assets/logos/volvo.svg";
import walthamOrient from "../../../assets/logos/waltham-orient.svg";
import wanderer from "../../../assets/logos/wanderer.svg";
import white from "../../../assets/logos/white.svg";
import willys from "../../../assets/logos/willys.svg";
import winton from "../../../assets/logos/winton.svg";
import wolseley from "../../../assets/logos/wolseley.svg";
import yale from "../../../assets/logos/yale.svg";

import type { MakeName } from "@/types/make";

export function getLogoFromMake(make: MakeName) {
  switch (make) {
    case "AC":
    case "Ac":
    case "ac":
      return ac;
    case "ASA":
      return asa;
    case "Acadian":
    case "acadian":
      return acadian;
    case "Abarth":
      return abarth;
    case "Acura":
      return acura;
    case "Adler Trumpf":
      return adlerTrumpf;
    case "Aermacchi":
      return aermacchi;
    case "Ahrens-Fox":
      return ahrensFox;
    case "Airfloat":
      return airfloat;
    case "amc":
    case "AMC":
      return amc;
    case "All American Racers":
    case "AM General":
      return allAmericanRacers;
    case "Allard":
      return allard;
    case "Allstate":
      return allstate;
    case "Alfa Romeo":
      return alfaromeo;
    case "Alpine":
      return alpine;
    case "Alvis":
      return alvis;
    case "American Bantam":
      return americanBantam;
    case "American":
      return american;
    case "Amphicar":
      return amphicar;
    case "Apollo":
      return apollo;
    case "Apperson":
      return apperson;
    case "Aston Martin":
    case "aston martin":
    case "Aston-Martin":
    case "aston-martin":
    case "astonmartin":
      return astonmartin;
    case "ATS":
      return ats;
    case "Auburn":
      return auburn;
    case "Audi":
      return audi;
    case "Austin":
      return austin;
    case "Austin Healey":
    case "Austin-Healey":
    case "austin_healey":
    case "austin-healey":
    case "austinhealey":
      return austin_healey;
    case "Avions Voisin":
      return avionsVoisin;
    case "Bentley":
      return bentley;
    case "Benz":
      return benz;
    case "BMW":
      return bmw;
    case "Bristol":
      return bristol;
    case "Brush":
      return brush;
    case "Bugatti":
      return bugatti;
    case "Buick":
      return buick;
    case "Cadillac":
      return cadillac;
    case "Cartercar":
      return cartercar;
    case "Chevrolet":
      return chevrolet;
    case "Chrysler":
      return chrysler;
    case "Cisitalia":
      return cisitalia;
    case "Citroën":
    case "Citroen":
      return citroen;
    case "Cole":
      return cole;
    case "Cole-1":
      return cole1;
    case "Crosley":
      return crosley;
    case "Cupra":
      return cupra;
    case "Cushman":
      return cushman;
    case "Daimler":
      return daimler;
    case "Davis":
      return davis;
    case "Delage":
      return delage;
    case "Delahaye":
      return delahaye;
    case "Dodge":
      return dodge;
    case "Duesenberg":
      return duesenberg;
    case "E-M-F":
      return emF;
    case "Erskine":
      return erie;
    case "Essex":
      return essex;
    case "Etnyre":
      return etnyre;
    case "Ferrari":
      return ferrari;
    case "Fiat":
      return fiat;
    case "Ford":
      return ford;
    case "Franklin":
      return franklin;
    case "Frontenac":
      return frontenac;
    case "GMC":
      return gmc;
    case "Gardner":
      return gardner;
    case "Ginetta":
      return ginetta;
    case "Healey":
      return healey;
    case "Honda":
      return honda;
    case "HRG":
      return hrg;
    case "Hispano-Suiza":
      return hsp;
    case "Horch":
      return horch;
    case "Hudson":
      return hudson;
    case "Humber":
      return humber;
    case "Hupmobile":
      return hupmobile;
    case "International Harverster":
      return internationalHarverster;
    case "Invicta":
      return invicta;
    case "Isotta Fraschini":
      return isottaFraschini;
    case "jaguar":
    case "Jaguar":
      return jaguar;
    case "Jeep":
      return jeep;
    case "Jeffery":
      return jeffery;
    case "Jensen":
      return jensen;
    case "Kaiser":
      return kaiser;
    case "Knox":
      return knox;
    case "Koenigsegg":
      return koenigsegg;
    case "LaSalle":
      return laSalle;
    case "Lagonda":
      return lagonda;
    case "Lanchester":
      return lanchester;
    case "Lamborghini":
      return lamborghini;
    case "Lancia":
      return lancia;
    case "Land Rover":
      return landrover;
    case "Lea-Francis":
      return leaFrancis;
    case "Lexus":
      return lexus;
    case "Lincoln":
      return lincoln;
    case "Locomobile":
      return locomo;
    case "Lozier":
      return lozier;
    case "Lotus":
      return lotus;
    case "MG":
      return mg;
    case "Maserati":
      return maserati;
    case "Mazda":
      return mazda;
    case "McLaren":
      return mclaren;
    case "Maybach":
      return maybach;
    case "Mercedes-Benz":
      return mercedes;
    case "Mercury":
      return mercury;
    case "Mini":
      return mini;
    case "Morgan":
      return morgan;
    case "Morris":
      return morris;
    case "Nash":
      return nash;
    case "Nissan":
      return nissan;
    case "NSU":
      return nsu;
    case "nissan":
      return nissan;
    case "Oldsmobile":
      return oldsmobile;
    case "Opel":
      return opel;
    case "Opel-1":
      return opel1;
    case "Pagani":
      return pagani;
    case "Packard":
      return packard;
    case "Peerless":
      return peerless;
    case "Peugeot":
      return peugeot;
    case "Pierce-Arrow":
      return pierceArrow;
    case "Playboy":
      return playboy;
    case "Plymouth":
      return plymouth;
    case "Pontiac":
      return pontiac;
    case "Porsche":
      return porsche;
    case "Rambler":
      return rambler;
    case "Renault":
      return renault;
    case "REO":
      return re0;
    case "Riley":
      return riley;
    case "Rolls-Royce":
      return rollsRoyce;
    case "Rols":
      return rols;
    case "Rover":
      return rover;
    case "Seat":
      return seat;
    case "Shelby":
      return shelby;
    case "Simca":
      return simca;
    case "Singer":
      return singer;
    case "Skoda":
      return skoda;
    case "Stanley":
      return stanley;
    case "Studebaker":
      return studebaker;
    case "Stutz":
      return stutz;
    case "Subaru":
      return subaru;
    case "Sunbeam-Talbot":
      return sunbeamTalbot;
    case "Suzuki":
      return suzuki;
    case "Talbot-Lago":
      return talbotLago;
    case "Tatra":
      return tata;
    case "Terraplane":
      return terraplane;
    case "Triumph":
      return triumph;
    case "Vauxhall":
      return vauxhall;
    case "Vauxhall-1":
      return vauxhall1;
    case "Waltham-Orient":
      return walthamOrient;
    case "Wanderer":
      return wanderer;
    case "White":
      return white;
    case "Willys":
      return willys;
    case "Winton":
      return winton;
    case "Wolseley":
      return wolseley;
    case "Yale":
      return yale;
    case "Volkswagen":
      return volksvagen;
    case "Volvo":
      return volvo;
    case "Tesla":
      return tesla;
    case "Toyota":
      return toyota;
    case "Peugeot":
      return peugeot;
    case "Pontiac":
      return pontiac;
    case "Renault":
      return renault;
    case "Nissan":
      return nissan;
    case "Cadillac":
      return cadillac;
    case "Citroen":
      return citroen;
    default:
      return defaultLogo;
  }
}
